module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_03.ddf24a55.jpg";